import { render } from "./TheFinance.vue?vue&type=template&id=5c223734&scoped=true&lang=true"
import script from "./TheFinance.vue?vue&type=script&lang=js"
export * from "./TheFinance.vue?vue&type=script&lang=js"

import "./TheFinance.vue?vue&type=style&index=0&id=5c223734&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c223734"]])

export default __exports__